import React from 'react';
import classnames from 'classnames';

import { section } from './styles.module.scss';

const AdditionalContent = ({ data }) => {

  return (
    <section className={classnames(section)}>
      {data.map((itemContent, i) => (
        <article
          key={i}
          className="pb-12"
        >
          {itemContent}
        </article>
      ))}
    </section>
  );
};

export default AdditionalContent;
